import React, {Component} from "react";
import PropTypes from "prop-types";
import dunzo from '../assets/dunzo.png'



class DunzoAppLinkComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div>
                <div><a href={"https://play.google.com/store/apps/details?id=runner.dunzo.com.dunzo_runner&hl=en_IN&gl=US"}> <img src={dunzo} style={{maxWidth:"100%", height:"auto"}} alt="dunzo"/></a></div>
                <div>
                Click <a style={{color: "white"}} href={'https://play.google.com/store/apps/details?id=runner.dunzo.com.dunzo_runner&hl=en_IN&gl=US'}>here</a> to download and register on the Dunzo App. We will reach out to you soon!/
                    DUNZO ಆಪ್‌ನ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಮತ್ತು ನೋಂದಾಯಿಸಲು <a style={{color: "white"}} href={'https://play.google.com/store/apps/details?id=runner.dunzo.com.dunzo_runner&hl=en_IN&gl=US'}>ಇಲ್ಲಿ</a> ಕ್ಲಿಕ್ ಮಾಡಿ. ನಾವು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತೇವೆ!
                </div>
                <br/>
                <a href={'https://play.google.com/store/apps/details?id=runner.dunzo.com.dunzo_runner&hl=en_IN&gl=US'} > <button style={{padding: '3px'}}>Click Here!</button></a>
            </div>
        );
    }
}

DunzoAppLinkComponent.propTypes = {
    steps: PropTypes.object,
};

DunzoAppLinkComponent.defaultProps = {
    steps: undefined,
};

export default DunzoAppLinkComponent;
